import * as yup from 'yup';

export const schema = yup.object({
  cvv: yup
    .string()
    .nullable()
    .required('La cantidad de caracteres ingresados es inválida')
    .matches(/^\d{3,4}$/, 'Revisa el dato'),
  installments: yup.number().required(),
  termsAndConditions: yup
    .boolean()
    .required('Deben aceptarse los términos y condiciones.')
    .oneOf([true], 'Deben aceptarse los términos y condiciones.')
});

export { yupResolver } from '@hookform/resolvers/yup';
